import React, { useState } from 'react';
import Select, { components } from 'react-select';
import { CreatedOnDate, ReconcilitionStartDate, ReconcilitionEndDate } from '../component/DatePicker';
import moment from 'moment';
import { KEY_RECONCILIATION_ACTIVE_TAB_MAP } from '@src/config/constant';
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';
import { useLanguage } from '../../src/context/LanguageContext';
import ReconcilationMoreFilter from './ReconcilationMoreFilter';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: number;
  label: string;
};

const attachmentFilterList: OptionType[] = [
    { value: 1, label: 'Attached' },
    { value: 2, label: 'Not Attached' },
]

const ReconciliationListFilter = (props: any) => {
    const { submitHandler, selectedFilters, setSelectedFilters, statusFilterList,assignUsers,config } = props;
    const {translations} = useLanguage();
    const [errorState, setErrorState] = useState<any>({
        start_date: '',
        end_date: '',
    });

    const handleChange = (selectedOption: any, key: string) => {
        let value: any = null;
        let updatedErrors = { ...errorState };

        if (key === 'created_on' || key === 'start_date' || key === 'end_date') {
            value = moment(selectedOption).format('YYYY-MM-DD');

            // Validate start_date if end_date exists
            if (key === 'start_date' && selectedFilters.end_date) {
                if (moment(value).isAfter(selectedFilters.end_date)) {
                    updatedErrors.start_date = "Start date must be less.";
                } else {
                    updatedErrors.start_date = '';
                }
            }

            // Validate end_date if start_date exists
            if (key === 'end_date' && selectedFilters.start_date) {
                if (moment(value).isBefore(selectedFilters.start_date)) {
                    updatedErrors.end_date = "End date must be greater.";
                } else {
                    updatedErrors.end_date = '';
                }
            }
        } else if (key === 'searchKeyword') {
            value = selectedOption.target.value;
        } else {
            value = selectedOption.value;
        }

        if (!updatedErrors.start_date && !updatedErrors.end_date) {
            setSelectedFilters((prev: any) => ({
                ...prev,
                [key]: value
            }));
        }

        setErrorState(updatedErrors);
    };

    /**
    * FILTER SET HANDLER
    */
    const onFilterSearch = () => {
        if (!errorState.start_date && !errorState.end_date && Object.keys(selectedFilters).length) {
            submitHandler({ page_number: 1, ...selectedFilters });
        }
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        if(Object.keys(selectedFilters).length){
            setSelectedFilters({});
            let updatedErrors = { ...errorState };
            updatedErrors = {
                start_date: '',
                end_date: '',
            };
            setErrorState(updatedErrors);
            submitHandler({ page_number: 1, activeTab: KEY_RECONCILIATION_ACTIVE_TAB_MAP['first'] });
        }
    }

  return (
    <div className="lead-list-filter">
    <div className="filter-filed-form">
        {filters.reconciliationFilters(translations).map((filter: any) => renderFilterField(filter, { selectedFilters, handleChange, translations,CustomValueContainer,
            options:{
                attachmentFilterList: attachmentFilterList, 
                statusFilterList: statusFilterList
            }
        }))}
        {/* <fieldset className="search-bx">
        <div className="material">
            <input
            type="text"
            placeholder="Search by Policy No,Customer Name, Customer Mob...."
            name="search"
            className="form-input"
            aria-label="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
            title="Search by Policy No, Customer Mobile or Insurance ID or Customer Name"
            onChange={(e) => handleChange(e, 'searchKeyword')} value={selectedFilters?.searchKeyword || ""} 
            />
            <i className="ic-search"></i>
        </div>
        </fieldset>

        <fieldset className="date-filed">
        <div className="material">
            <CreatedOnDate selectedFilters={selectedFilters} handleChange={handleChange}/>
        </div>
        </fieldset>
        <fieldset className="date-filed">
        <div className="material">
            <ReconcilitionStartDate selectedFilters={selectedFilters} placeholder="Start Date" handleChange={handleChange}/>
            {errorState.start_date && <span  className = ""style={{ color: 'red' }}>{errorState.start_date}</span>} 
        </div>
        </fieldset>
        <fieldset className="date-filed">
        <div className="material">
            <ReconcilitionEndDate selectedFilters={selectedFilters} placeholder="End Date" handleChange={handleChange}/>
            {errorState.end_date && <span  className = ""style={{ color: 'red' }}>{errorState.end_date}</span>} 
        </div>
        </fieldset>

        <fieldset className="single-select">
        <div className="material">
            <Select<OptionType>
            components={{ ValueContainer: CustomValueContainer }}
            options={attachmentFilterList}
            placeholder="Attachment"
            className="react-select"
            classNamePrefix="react-select"
            isClearable
            onChange={(e: any) => handleChange(e, 'attachment')}
            value={attachmentFilterList.find((option) => option.value === selectedFilters.attachment) || null}
            />
        </div>
        </fieldset>

        <fieldset className="single-select">
        <div className="material">
            <Select<OptionType>
            components={{ ValueContainer: CustomValueContainer }}
            options={statusFilterList}
            placeholder="Status"
            className="react-select"
            classNamePrefix="react-select"
            isClearable
            onChange={(e: any) => handleChange(e, 'status')}
            value={statusFilterList.find((option: any) => option.value === selectedFilters.status) || null}
            />
        </div>
        </fieldset> */}
        {/* <div className="btn-submit-reset">
            <button className="btn-primary" onClick={onFilterSearch}>Search</button>
            <button className="btn-reset" onClick={onFilterReset}>Reset</button>
        </div> */}
        <div className="more-filter">
            <ReconcilationMoreFilter submitHandler={submitHandler} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} assignUsers={assignUsers} config={config}/>
        </div>
    </div>
    </div>
  );
}
export default ReconciliationListFilter;

